import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import AboutBox from './AboutBox';
import Footer from './Footer';
import InfoSection from './InfoSection';
import LoadingScreen from './LoadingScreen';
import MapUi from './MapUi';
import MapViewButton from './MapViewButton';
import Panorama from './Panorama';
import ProgressBar from './ProgressBar';
import TopSection from './TopSection';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    user-select: none;
  }

  html, body, #root {
    /* required on safari? https://stackoverflow.com/a/18037511/676798 */
    position: relative;

    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;

    -webkit-tap-highlight-color:  rgba(255, 235, 235, 0.1);
    -webkit-text-size-adjust: none; /* Never autoresize text, cargo-culting */

    /* to prevent scrolling left for back, doesn't work in safari */
    /* also prevent refresh: */
    /* https://developers.google.com/web/updates/2017/11/overscroll-behavior */
    overscroll-behavior: none;

    background-color: #000;
  }

  body {
    /* prevent scrolling body up/down */
    position: fixed;
  }

  .hidden {
    visibility: hidden;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

/**
 * Application definition.
 * @return {jsx} jsx.
 */
const App = () => (
  <Wrapper>
    <GlobalStyle />

    <Panorama />
    <MapUi />
    <MapViewButton />

    <TopSection />

    <InfoSection />
    <LoadingScreen />
    <AboutBox />
    <ProgressBar />
    <Footer />
  </Wrapper>
);

export default App;
